// extracted by mini-css-extract-plugin
export default {"wrapper":"Ri-z","reviewFormSuccess":"Si-z","header":"Ti-z","message":"Ui-z","paragraph":"Vi-z","lottieContainer":"Wi-z"};